"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/* eslint-disable react-hooks/rules-of-hooks */
const react_1 = tslib_1.__importStar(require("react"));
const context_1 = require("./context");
const hooks_1 = require("./hooks");
const react_hanger_1 = require("react-hanger");
const template_parser_1 = require("@osmosys/template-parser");
const hooks_2 = require("../EmailCanvas/hooks");
const hooks_3 = require("../../hooks");
const react_visibility_sensor_1 = tslib_1.__importDefault(require("react-visibility-sensor"));
const react_if_1 = require("react-if");
const ConverterPanelTab_1 = require("../EmailCanvas/panels/ConverterPanel/ConverterPanelTab");
const Inner_1 = require("./Inner");
const BlockOverlay_1 = require("./BlockOverlay");
exports.BlockCanvas = props => {
    // Props
    const { block, onChange, conversionStatus } = props;
    if (block.type === 'social') {
        return null;
    }
    const { state: { activeContentImportBlockIdx, conversionPanelConversions }, } = hooks_2.useEmailCanvasContext();
    const { dispatchCanvasAction } = hooks_2.useEmailCanvasUpdate();
    const { adminRole } = hooks_3.useOsmosysContext();
    // Meta
    const meta = hooks_1.useEmailCanvasBlockMeta(props, adminRole, activeContentImportBlockIdx);
    // State
    const { state, setState } = react_hanger_1.useSetState({});
    const updateBlock = react_1.useCallback((newBlock) => {
        onChange(Object.assign(Object.assign({}, block), newBlock));
    }, [onChange, block]);
    const setActivelyImportingContent = react_1.useCallback(() => {
        dispatchCanvasAction({
            data: {
                activeContentImportBlockIdx: meta.indexPath,
            },
            type: 'state',
        });
    }, [dispatchCanvasAction, meta.indexPath]);
    const editImportedContent = react_1.useCallback(() => {
        updateBlock(Object.assign({}, template_parser_1.nestedContentEdit(block)));
    }, [updateBlock, template_parser_1.nestedContentEdit, block]);
    const populateWithContent = react_1.useCallback((cf, ci) => {
        updateBlock(Object.assign({}, template_parser_1.nestedContentPopulation(block, cf, ci)));
    }, [updateBlock, block, template_parser_1.nestedContentPopulation]);
    const clearBlockMemo = react_1.useCallback(() => {
        updateBlock(Object.assign({}, template_parser_1.clearBlock(block)));
    }, [updateBlock, block, template_parser_1.clearBlock]);
    const prevIdxPath = react_hanger_1.usePrevious(meta.idxPath);
    const setConversionStatus = react_1.useCallback(status => {
        const newConversionPanelConversions = Object.assign(Object.assign({}, conversionPanelConversions), { [meta.idxPath]: {
                error: false,
                loading: false,
                stopped: false,
                success: false,
                [`${status}`]: true,
            } });
        if (!meta.idxPath && newConversionPanelConversions[meta.idxPath]) {
            // If the idxPath doesn't exist, delete it
            delete newConversionPanelConversions[meta.idxPath];
        }
        // If the idxPath has changed, delete from the conversions object
        if (meta.idxPath &&
            prevIdxPath &&
            meta.idxPath !== prevIdxPath &&
            prevIdxPath &&
            newConversionPanelConversions[prevIdxPath]) {
            delete newConversionPanelConversions[prevIdxPath];
        }
        dispatchCanvasAction({
            data: {
                conversionPanelConversions: newConversionPanelConversions,
            },
            type: 'state',
        });
    }, [
        dispatchCanvasAction,
        conversionPanelConversions,
        meta.idxPath,
        prevIdxPath,
    ]);
    const [el, attempts] = hooks_1.useEditorViewportEl();
    const conversionIsRunningOrHasRan = !!(conversionStatus &&
        (conversionStatus.loading ||
            conversionStatus.error ||
            conversionStatus.success ||
            conversionStatus.stopped));
    // const { data } = useQuery<{ contentMapping: ContentMapping }>(
    //   contentMapping,
    //   {
    //     skip: !!block?.conversions || !block?.contentFeed?.contentMapping,
    //     variables: {
    //       id: block?.contentFeed?.contentMapping?.id,
    //     },
    //   }
    // );
    // const loadedConversions = data?.contentMapping?.conversions;
    // console.log({ loadedConversions });
    // useEffect(() => {
    // });
    return (react_1.default.createElement(react_visibility_sensor_1.default, { containment: el, partialVisibility: true, offset: { bottom: -300, top: -300 }, resizeCheck: true, scrollCheck: true, active: meta.parentBlock
            ? false
            : attempts === 0 && props.parentIsVisible !== false }, ({ isVisible }) => {
        const blockIsVisible = isVisible || (props.parentBlock && props.parentIsVisible);
        return (react_1.default.createElement(context_1.EmailCanvasBlockDetailChangeContext.Provider, { value: {
                clearBlock: clearBlockMemo,
                editImportedContent,
                populateWithContent,
                setActivelyImportingContent,
                setConversionStatus,
                setState,
                updateBlock,
            } },
            react_1.default.createElement(context_1.EmailCanvasBlockDetailContext.Provider, { value: {
                    block,
                    blockIsVisible,
                    conversionIsRunningOrHasRan,
                    conversionPanelConversions,
                    meta,
                    state,
                } },
                react_1.default.createElement(Inner_1.BlockCanvasInner, { isFirst: meta.isFirst, isChildBlock: meta.isChildBlock, isLast: meta.isLast, blockName: block.name },
                    react_1.default.createElement(react_if_1.When, { condition: !!meta.showOverlay }, () => (react_1.default.createElement(BlockOverlay_1.EmailCanvasBlockOverlay, { block: block, meta: meta, adminRole: adminRole, updateBlock: updateBlock, isVisible: blockIsVisible, contentImportIsActive: meta.contentImportIsActive }))),
                    react_1.default.createElement(react_if_1.When, { condition: conversionIsRunningOrHasRan }, () => {
                        return (react_1.default.createElement(ConverterPanelTab_1.EmailCanvasConverterPanelTab, { block: block, idxPath: meta.idxPath, value: meta.value, linkToPost: meta.linkToPost, conversionStatus: conversionStatus, displayName: meta.displayName, onChange: contentStr => {
                                updateBlock({
                                    contentFeed: null,
                                    contentFieldKey: null,
                                    contentItem: null,
                                    contentSlotNumber: null,
                                    contentStr,
                                });
                            }, setConversionStatus: setConversionStatus }));
                    })))));
    }));
};
//# sourceMappingURL=index.js.map